import Index from '../components/SubCategoryProductOrder/Index';

let routes = {
    path: '/subCategoryProductOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/subCategoryProductOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/subCategoryProductOrder.js